const COUNTER_MAX_VALUE = 99

export function formatCounterValue(value: number | undefined): string {
    if (!value || value <= 0) return ''
    if (value > COUNTER_MAX_VALUE) return `${COUNTER_MAX_VALUE}+`

    return String(value)
}
